import React from 'react';

import { ChildrenProps } from '../../../../../../utils';
import { ClassNameDecorator } from '../../../../../decorators';
import { ClassInjector } from '../../../../../injectors';

import './PrimaryHeading.scoped.scss';

const PrimaryHeading: ClassNameDecorator<ChildrenProps> = ({ children, className }) => {
  return (
    <ClassInjector classNames="primary-heading" oldClassName={className}>
      {children}
    </ClassInjector>
  );
};

export default PrimaryHeading;
